var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhiteSearchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 3.98701C6.92276 3.98701 4 6.8906 4 10.5003C4 14.1101 6.92276 17.0137 10.5 17.0137C14.0772 17.0137 17 14.1101 17 10.5003C17 6.8906 14.0772 3.98701 10.5 3.98701ZM2 10.5003C2 5.82581 5.79297 2.01367 10.5 2.01367C15.207 2.01367 19 5.82581 19 10.5003C19 12.4856 18.3158 14.3154 17.1681 15.7636L20.7118 19.3074C21.0997 19.6953 21.0955 20.32 20.7023 20.7027C20.3092 21.0854 19.6761 21.0812 19.2882 20.6933L15.7614 17.1666C14.3158 18.3059 12.4896 18.987 10.5 18.987C5.79297 18.987 2 15.1749 2 10.5003Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteSearchIcon);
export default __webpack_public_path__ + "static/media/white_search_icon.65e625bf.svg";
export { ForwardRef as ReactComponent };